import { enablePointerEvents } from '@utils/pointer-events-control';
import { config, gameState } from '@js/state';

let points;
let array = [];

const dotArray = [];

const sliderDrag = false;

const leftClick = 0;

const rightClick = 0;

let distance = 842;

let attempts = 0;

let mul = 0;

let hintOn = false;

let changeQuestion = false;

let gap;

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {
    //data loaded in start scene

    for (let i = 1; i <= 10; i++) {
      this.load.image(
        'question_' + i,
        'assets/GameScreenAssets/questionImages/question_' + i + '.png',
      );
      this.load.image(
        'qBoard_' + i,
        'assets/GameScreenAssets/questionImages/Q Board_' + i + '.png',
      );
    }

    this.load.multiatlas(
      'heliDropWrongAnim',
      'assets/GameScreenAssets/heliDropWrongAnim/heliDropWrongAnim.json',
      'assets/GameScreenAssets/heliDropWrongAnim',
    );

    this.load.atlas(
      'hintFinalAnim',
      'assets/GameScreenAssets/hintFinalAnim.png',
      'assets/GameScreenAssets/hintFinalAnim.json',
    );

    this.load.image('hint_1', 'assets/GameScreenAssets/hint_1.png');
    this.load.image('hint_2', 'assets/GameScreenAssets/hint_2.png');

    this.load.image('closeHintButton', 'assets/GameScreenAssets/closeHintIconhdpi.png');

    this.load.image('hint', 'assets/Hint.png');
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    this.tweens.add({
      targets: config.audio.heliaudio,
      delay: 1000,
      volume: 0.3,
      duration: 3000,
      onComplete: () => {},
    });

    for (let i = 1; i <= 10; i++) {
      config.audio['qa' + i] = this.sound.add('qa' + i).setVolume(0.3);
    }

    config.audio.yayaudio = this.sound.add('yayaudio').setVolume(0.05);
    //config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.1);

    config.audio.hintaudio = this.sound.add('hintaudio').setVolume(0.05);
    config.audio.incorrectdropaudio = this.sound.add('incorrectdropaudio').setVolume(0.1);
    config.audio.wrongdivideaudio = this.sound.add('wrongdivideaudio').setVolume(0.05);
    config.audio.correctdropaudio = this.sound.add('correctdropaudio').setVolume(0.05);
    config.audio.correctdivideaudio = this.sound
      .add('correctdivideaudio')
      .setVolume(0.05);
    this.heliaudio = this.sound.add('heliaudio').setVolume(0.005);

    this.cameras.main.fadeIn(1000, 255, 255, 255);

    gameState.questionNumber = 1;

    this.add
      .sprite(config.width / 2, config.height / 2, 'tutorialSceneBG')
      .setDisplaySize(1280, 720);

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, 'overlay')
      .setAlpha(0.6)
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setDisplaySize(1280, 720)
      .setVisible(false);

    this.numberLine = this.add
      .sprite(config.width / 2, config.height - 127, 'numberLine')
      .setScale(0.668)
      .setFrame(3);
    this.speechBubble = this.add
      .sprite(210, 230, 'question_1')
      .setScale(0.67)
      .setAlpha(0)
      .setOrigin(0, 0.1);
    this.qBoard = this.add
      .sprite(170, 250, 'qBoard_1')
      .setScale(0.67)
      .setOrigin(0, 1)
      .setAlpha(0);
    this.sliderBar = this.add
      .sprite(config.width / 2 - 60, 650, 'sliderBar')
      .setScale(0.67);

    this.sliderButton = this.add
      .sprite(config.width / 2 - 155, 650, 'sliderButton')
      .setScale(0.67)
      .setInteractive({
        cursor: 'pointer',
      });

    this.checkButton = this.add
      .sprite(config.width / 2 + 150, 650, 'checkButtonAnim')
      .setScale(0.67)
      .setInteractive({
        cursor: 'pointer',
        pixelPerfect: true,
      });

    this.add.sprite(942.5, 62.5, 'correctCounter').setScale(0.67);

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('checkButtonAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'CHECK BREATHING',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    /*------Hint Icon and Anim------*/

    this.hint = this.add
      .sprite(295, 538, 'hint_1')
      .setScale(0.67)
      .setVisible(false)
      .setDepth(2);

    //this.add.sprite(80, 650, "hint").setScale(0.8);

    this.hintButton = this.physics.add
      .sprite(80, 650, 'hintFinalAnim')
      .setScale(0.8)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(2);

    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'hintBreathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.closeHintButton = this.add
      .sprite(540, 415, 'closeHintButton')
      .setVisible(false)
      .setInteractive({ cursor: 'pointer' })
      .setDepth(2);

    //adding of hint images

    /*------------------------------*/

    //Hint button event

    this.hintButton.on(
      'pointerup',
      function (pointer) {
        gameState.hints += 1;

        this.hintButton.play('idle');

        if (attempts == 1) {
          config.audio.hintaudio.play();
          this.hint.setTexture('hint_1');

          this.leftButton.disableInteractive();
          this.rightButton.disableInteractive();

          this.dropButton.disableInteractive();

          this.overlay.setVisible(true).setDepth(1);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          config.audio.hintaudio.play();
          this.hint.setTexture('hint_2');
          this.leftButton.disableInteractive();
          this.rightButton.disableInteractive();

          this.dropButton.disableInteractive();

          this.overlay.setVisible(true).setDepth(1);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        }
      },
      this,
    );

    this.closeHintButton.on(
      'pointerup',
      function (pointer) {
        this.hintButton.disableInteractive();
        this.leftButton.setInteractive();
        this.rightButton.setInteractive();

        this.dropButton.setInteractive();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play('pop_out');

        hintOn = false;
      },
      this,
    );

    //

    this.checkConfetti = this.add.sprite(
      config.width / 2 + 150,
      680,
      'checkConfettiAnim',
    );
    this.anims.create({
      key: 'confetti',
      frames: this.anims.generateFrameNames('checkConfettiAnim', {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: 'checkconfetti',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.checkButtonRight = this.add
      .sprite(config.width / 2 + 150, 650, 'checkRightAnim')
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: 'correct',
      frames: this.anims.generateFrameNames('checkRightAnim', {
        start: 1,
        end: 32,
        zeroPad: 0,
        prefix: 'CHECK RIGHT',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.buttonWrong = this.add
      .sprite(config.width / 2 + 150, 650, 'buttonWrongAnim')
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: 'wrong',
      frames: this.anims.generateFrameNames('buttonWrongAnim', {
        start: 1,
        end: 42,
        zeroPad: 0,
        prefix: 'checkwrong',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.heliHover = this.physics.add
      .sprite(-200, 358, 'heliHoverAnim')
      .setScale(0.67)
      .setDepth(1);
    this.anims.create({
      key: 'hover',
      frames: this.anims.generateFrameNames('heliHoverAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.anims.create({
      key: 'drop',
      frames: this.anims.generateFrameNames('heliDropAnim', {
        start: 0,
        end: 359,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: 'dropWrong',
      frames: this.anims.generateFrameNames('heliDropWrongAnim', {
        start: 0,
        end: 90,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    // this.sliderButton.drag = this.plugins.get("rexdragplugin").add(this.sliderButton, {
    //   axis: "h",
    //   endPoints: [
    //     {
    //       x: 485,
    //       y: 650,
    //     },
    //     {
    //       x: 665,
    //       y: 650,
    //     },
    //   ],
    // });

    //this.sliderButton.disableInteractive();

    this.input.setDraggable(this.sliderButton);

    //this.sliderButton.drag.drag();

    this.sliderText = this.add
      .text(this.sliderButton.x + 1, this.sliderButton.y + 1.5, gameState.value, {
        fontFamily: 'font1',
        fontSize: '20px',
        fill: '000000',
      })
      .setOrigin(0.5, 0.5);

    gameState.value = 1;

    this.input.on(
      'drag',
      function (pointer, gameObject, dragX, dragY) {
        gameObject.x = dragX;

        if (gameState.questionNumber == 1 || gameState.questionNumber == 5) {
          if (dragX > 593 + 9) {
            dragX = 593 + 9;
            this.sliderButton.x = 593 + 9;
          }
        } else if (gameState.questionNumber == 2) {
          if (dragX > 521 + 9) {
            dragX = 521 + 9;
            this.sliderButton.x = 521 + 9;
          }
        } else if (gameState.questionNumber == 3 || gameState.questionNumber == 7) {
          if (dragX > 557 + 9) {
            dragX = 557 + 9;
            this.sliderButton.x = 557 + 9;
          }
        } else if (gameState.questionNumber == 8) {
          if (dragX > 629 + 9) {
            dragX = 629 + 9;
            this.sliderButton.x = 629 + 9;
          }
        } else if (
          gameState.questionNumber == 4 ||
          gameState.questionNumber == 6 ||
          gameState.questionNumber == 9 ||
          gameState.questionNumber == 10
        ) {
          if (dragX > 665) {
            dragX = 665;
            this.sliderButton.x = 665;
          }
        }
      },
      this,
    );

    this.heliHover.play('hover');
    this.moveHeli_one(3000, -200, 642);

    this.speechBubbleAppear();

    this.qBoardAppear(642, 8000, 0, 1, 0, 0.67);

    this.graphics = this.add.graphics();

    this.curve = new Phaser.Curves.Line(
      new Phaser.Math.Vector2(184, 575.5),
      new Phaser.Math.Vector2(1098, 575.5),
    );

    this.leftButton = this.add.sprite(494, 800, 'leftButton').setScale(0.67);

    this.anims.create({
      key: 'leftpress',
      frames: this.anims.generateFrameNames('leftButton', {
        start: 1,
        end: 2,
        zeroPad: 0,
        prefix: 'leftButton',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.rightButton = this.add.sprite(575, 800, 'rightButton').setScale(0.67);

    this.anims.create({
      key: 'rightpress',
      frames: this.anims.generateFrameNames('rightButton', {
        start: 1,
        end: 2,
        zeroPad: 0,
        prefix: 'rightButton',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.leftButton.on(
      'pointerover',
      () => {
        this.leftButton.setTint(0xc4c4c4);
      },
      this,
    );
    this.leftButton.on(
      'pointerout',
      () => {
        this.leftButton.setTint();
      },
      this,
    );

    this.rightButton.on(
      'pointerover',
      () => {
        this.rightButton.setTint(0xc4c4c4);
      },
      this,
    );

    this.rightButton.on(
      'pointerout',
      () => {
        this.rightButton.setTint();
      },
      this,
    );

    this.leftButton.on(
      'pointerdown',
      () => {
        if (this.heliHover.x > 642) {
          this.leftButton.setTint();

          this.rightButton.disableInteractive();
          this.leftButton.disableInteractive();

          this.leftButton.play('leftpress');
          this.leftButton.y += 2.68;
          this.yellowPoint.setVisible(false);

          this.dropButton.disableInteractive();
          this.qBoard.setAlpha(0);

          this.moveHeliLeft(2000, 0, this.heliHover.x);
        }
      },
      this,
    );

    this.rightButton.on(
      'pointerdown',
      () => {
        if (this.heliHover.x <= 1500) {
          this.rightButton.setTint();
          this.leftButton.disableInteractive();
          this.rightButton.disableInteractive();

          this.rightButton.play('rightpress');
          this.rightButton.y += 2.68;

          this.yellowPoint.setVisible(false);

          this.dropButton.disableInteractive();
          this.qBoard.setAlpha(0);

          this.moveHeliRight(2000, 0, this.heliHover.x);
        }
      },
      this,
    );

    this.dropButton = this.add
      .sprite(config.width / 2 + 80, 800, 'dropButtonAnim')
      .setScale(0.67)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    this.linePoints = this.add.group();

    this.curve.draw(this.graphics);

    this.yellowPoint = this.add
      .sprite(184.5, 575.5, 'yellowPoint')
      .setScale(0.67)
      .setVisible(false)
      .setDepth(1);

    this.checkButton.on(
      'pointerover',
      function (pointer) {
        this.checkButton.setTint(0xc4c4c4);
      },
      this,
    );

    this.checkButton.on(
      'pointerout',
      function (pointer) {
        this.checkButton.setTint();
      },
      this,
    );

    this.checkButton.on(
      'pointerup',
      function (pointer) {
        this.checkButton.setTint();
        this.checkButton.disableInteractive();

        if (gameState.questionNumber == 1 && gameState.value == 4) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 2 && gameState.value == 2) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 3 && gameState.value == 3) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 4 && gameState.value == 9) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 5 && gameState.value == 4) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 6 && gameState.value == 6) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 7 && gameState.value == 3) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 8 && gameState.value == 5) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 9 && gameState.value == 7) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else if (gameState.questionNumber == 10 && gameState.value == 8) {
          this.lineDivideCorrect();
          config.audio.correctdivideaudio.play();
        } else {
          this.lineDivideIncorrect();
          config.audio.wrongdivideaudio.play();
        }
      },
      this,
    );

    this.dropButton.on(
      'pointerup',
      function (pointer) {
        if (gameState.questionNumber == 1 && this.heliHover.x == 642 + distance) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (gameState.questionNumber == 2 && this.heliHover.x == 642 + distance) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 3 &&
          this.heliHover.x == 642 + distance * 2
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 4 &&
          this.heliHover.x == 642 + distance * 4
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 5 &&
          this.heliHover.x == 642 + distance * 3
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 6 &&
          Math.trunc(this.heliHover.x) == Math.trunc(642 + distance * 5)
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 7 &&
          this.heliHover.x == 642 + distance * 1
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 8 &&
          this.heliHover.x == 642 + distance * 4
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 9 &&
          this.heliHover.x == 642 + distance * 3
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else if (
          gameState.questionNumber == 10 &&
          this.heliHover.x == 642 + distance * 7
        ) {
          this.dropCorrect();
          config.audio.correctdropaudio.play();
        } else {
          this.dropIncorrect();
          config.audio.incorrectdropaudio.play();
        }
      },
      this,
    );
  }
  /*---------Custom Functions---------*/

  moveYellowPoint() {
    //change the location of the yellow point based on the position of the helicopter
    //make it visible at that point

    this.yellowPoint.setX(this.heliHover.x - 457);
    this.yellowPoint.setVisible(true);
  }

  dropCorrect() {
    //correct drop animation should play - Done
    //color of dot should change - Done
    //correct button animation should play - Done
    //fade in fade out
    //next question and reset the position of the helicopter and slider and delete all points on number line
    //score increases - done
    //add game over condition to move to end scene
    //hide the yellow point

    this.leftButton.disableInteractive();
    this.rightButton.disableInteractive();

    if (hintOn) {
      hintOn = false;
      this.hintButton.play('pop_out');
    }

    this.yellowPoint.setTexture('greenPoint');

    this.time.delayedCall(
      4000,
      function () {
        this.yellowPoint.setTexture('yellowPoint');
        this.yellowPoint.setVisible(false);
      },
      [],
      this,
    );

    mul++;

    this.add
      .sprite(942.5 + 34 * mul, 62.5, 'correctCounter')
      .setScale(0.67)
      .setDepth(1);

    //976.5, 942.5, 34

    this.qBoard.setAlpha(0);

    gameState.score += 1;
    gameState.attempted += 1;

    if (gameState.score == 5) {
      gameState.gameWin = true;

      this.time.delayedCall(
        4500,
        function () {
          this.scene.stop('TutorialScene');
          //config.audio.heliaudio.stop();
          config.audio.bgaudio.stop();
          config.audio.yayaudio.play();
          this.scene.start('EndScene');
        },
        [],
        this,
      );
    }
    this.dropButton.setVisible(false);
    this.checkButtonRight.setY(this.dropButton.y);
    this.checkButtonRight.setVisible(true);

    this.checkButtonRight.play('correct');

    this.checkConfetti.setPosition(config.width / 2 + 80, 680);
    this.checkConfetti.play('confetti');

    if (gameState.questionNumber == 1) {
      array[1].setFrame(2);
    } else if (gameState.questionNumber == 2) {
      array[1].setFrame(2);
    } else if (gameState.questionNumber == 3) {
      array[2].setFrame(2);
    } else if (gameState.questionNumber == 4) {
      array[2].setFrame(2);
    } else if (gameState.questionNumber == 5) {
      array[3].setFrame(2);
    } else if (gameState.questionNumber == 6) {
      array[3].setFrame(2);
    } else if (gameState.questionNumber == 7) {
      array[2].setFrame(2);
    } else if (gameState.questionNumber == 8) {
      array[4].setFrame(2);
    } else if (gameState.questionNumber == 9) {
      array[3].setFrame(2);
    } else if (gameState.questionNumber == 10) {
      array[5].setFrame(2);
    }

    this.heliHover.setTexture('heliDropAnim');
    this.heliHover.play('drop');

    this.tweens.add({
      targets: config.audio.heliaudio,
      delay: 2000,
      volume: 0,
      duration: 3000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      5000,
      function () {
        this.cameras.main.fadeOut(1000, 255, 255, 255);
        this.cameras.main.once(
          'camerafadeoutcomplete',
          function (camera) {
            //change question
            gameState.questionNumber += 1;
            this.changeQuestion();

            this.cameras.main.fadeIn(1000, 255, 255, 255);
            this.tweens.add({
              targets: config.audio.heliaudio,
              delay: 2000,
              volume: 0.3,
              duration: 3000,
              onComplete: () => {},
            });
          },
          this,
        );
      },
      [],
      this,
    );
  }

  changeQuestion() {
    //move helicopter to original position
    //delete all the points on the number line
    //reset slider button position

    attempts = 0;

    changeQuestion = true;

    this.sliderText.setText(1);

    this.sliderText.setVisible(true);

    this.checkButtonRight.setPosition(config.width / 2 + 150, 650).setVisible(false);

    this.buttonWrong.setPosition(config.width / 2 + 150, 650);

    this.checkConfetti.setPosition(config.width / 2 + 150, 680);

    this.heliHover.setTexture('heliHoverAnim');
    this.heliHover.play('hover');

    this.moveHeli_one(3000, -200, 642);
    this.speechBubbleAppear();

    // this.time.delayedCall(
    //   1500,
    //   function () {
    //     this.sliderButton.drag.setEnable(true);
    //   },
    //   [],
    //   this
    // );

    this.qBoardAppear(642, 8000, 0, 1, 0, 0.67);

    this.leftButton.disableInteractive();
    this.rightButton.disableInteractive();

    this.leftButton.setVisible(false);
    this.rightButton.setVisible(false);
    this.leftButton.setY(810);

    this.rightButton.setY(850);

    this.dropButton.setVisible(false);
    this.dropButton.setY(800);

    this.sliderBar.setVisible(true);
    this.sliderButton.setVisible(true);
    this.checkButton.setVisible(true);

    this.checkButton.setInteractive();

    this.time.delayedCall(
      4000,
      function () {
        changeQuestion = false;
      },
      [],
      this,
    );

    //console.log(true);
  }
  dropIncorrect() {
    //hint icon pops
    //attempt increases - done
    //incorrect drop animation plays
    //incorrect button animation plays - done
    //after 3 incorrect attempts, question changes, reset
    //in 2 incorrect attempts, show hint 2
    //add game over condition to move to end scene

    attempts += 1;

    this.yellowPoint.setTexture('redPoint');

    this.time.delayedCall(
      1000,
      function () {
        this.yellowPoint.setTexture('yellowPoint');
      },
      [],
      this,
    );

    //this.qBoard.setAlpha(0);

    if (attempts == 1 || attempts == 2) {
      hintOn = true;
      this.hintButton.setInteractive();
      this.hintButton.play('pop');
    }

    this.time.delayedCall(
      1500,
      function () {
        if (hintOn) {
          this.hintButton.play('hintBreathe');
        }
      },
      [],
      this,
    );

    if (attempts == 3) {
      if (hintOn == true) {
        this.qBoard.setAlpha(0);
        this.hintButton.play('pop_out');
        hintOn = false;
      }

      gameState.questionNumber += 1;
      gameState.attempted += 1;

      if (gameState.attempted == 10) {
        gameState.gameWin = false;
        this.scene.stop('TutorialScene');
        config.audio.heliaudio.stop();
        config.audio.bgaudio.stop();
        this.scene.start('EndScene');
      }

      this.tweens.add({
        targets: config.audio.heliaudio,
        delay: 100,
        volume: 0,
        duration: 500,
        onComplete: () => {},
      });

      this.cameras.main.fadeOut(1000, 255, 255, 255);
      this.cameras.main.once(
        'camerafadeoutcomplete',
        function (camera) {
          //change question
          this.changeQuestion();

          this.cameras.main.fadeIn(1000, 255, 255, 255);
        },
        this,
      );

      this.tweens.add({
        targets: config.audio.heliaudio,
        delay: 2500,
        volume: 0.3,
        duration: 2000,
        onComplete: () => {},
      });
    } //start from here

    this.dropButton.setVisible(false);
    this.buttonWrong.setY(this.dropButton.y);
    this.buttonWrong.setVisible(true);

    this.buttonWrong.play('wrong');

    this.heliHover.setTexture('heliDropWrongAnim');
    this.heliHover.play('dropWrong');

    this.heliHover.on(
      'animationcomplete',
      function () {
        this.heliHover.setTexture('heliHoverAnim');
        this.heliHover.play('hover');
      },
      this,
    );

    this.time.delayedCall(
      1000,
      function () {
        this.dropButton.setVisible(true);
        this.buttonWrong.setVisible(false);

        this.dropButton.setInteractive();
      },
      [],
      this,
    );
  }

  lineDivideCorrect() {
    //turn the numberline and the points red and turn them back to black color
    this.checkButton.setVisible(false);
    this.checkButtonRight.setY(this.checkButton.y);
    this.checkButtonRight.setVisible(true);

    this.sliderButton.disableInteractive();

    this.checkButtonRight.play('correct');

    this.checkConfetti.play('confetti');

    this.numberLine.setFrame(1);

    array[0].setFrame(2);

    // for (let i = 1; i < array.length; i++) {
    //   array[i].setFrame(2);
    // }

    this.dotColorChange('greenPoint');

    this.time.delayedCall(
      1800,
      function () {
        this.leftButton.setVisible(true);
        this.rightButton.setVisible(true);

        this.dropButton.setVisible(true);

        this.controlsSlideIn(
          [this.leftButton, this.rightButton, this.dropButton],
          800,
          650,
        );

        // for (let i = 0; i < array.length; i++) {
        //   array[i].setFrame(3);
        // }

        dotArray.forEach(element => {
          element.destroy();
        });

        this.numberLine.setFrame(3);

        this.sliderBar.setVisible(false);

        this.sliderButton.setVisible(false);
        this.sliderText.setVisible(false);

        this.checkButton.setVisible(false);

        this.checkButtonRight.setVisible(false);

        this.checkButtonRight.setPosition(config.width / 2 + 80, 670);

        this.buttonWrong.setPosition(config.width / 2 + 80, 670);
      },
      [],
      this,
    );

    this.time.delayedCall(
      2500,
      function () {
        this.leftButton.setInteractive({ cursor: 'pointer' });
        this.rightButton.setInteractive({ cursor: 'pointer' });
      },
      [],
      this,
    );
  }

  dotColorChange(assetKey) {
    gap = 914 / gameState.value;
    for (let i = 0; i < gameState.value; i++) {
      const x = this.add
        .sprite(184 + gap * i + 0.7, 575.5, assetKey)
        .setScale(0.67)
        .setDepth(1);
      dotArray.push(x);
      //console.log(this.linePoints);
    }
  }

  lineDivideIncorrect() {
    this.checkButton.setVisible(false);
    this.buttonWrong.setY(this.checkButton.y);
    this.buttonWrong.setVisible(true);

    this.numberLine.setFrame(2);

    // for (let i = 1; i < array.length; i++) {
    //   array[i].setTexture("redPoint");
    // }

    this.dotColorChange('redPoint');

    this.time.delayedCall(
      1000,
      function () {
        this.numberLine.setFrame(3);
        for (let i = 1; i < array.length; i++) {
          // array[i].setTexture("linePoint");
          dotArray.forEach(element => {
            element.destroy();
          });

          array[i].setFrame(3);
        }
      },
      [],
      this,
    );
    this.buttonWrong.play('wrong');

    this.time.delayedCall(
      1000,
      function () {
        this.checkButton.setVisible(true);
        this.buttonWrong.setVisible(false);

        this.checkButton.setInteractive();
      },
      [],
      this,
    );
  }

  numberLineClear() {
    array.forEach(element => {
      element.destroy();
    });
  }

  numberLineDivide(divisions) {
    //array = this.linePoints.getChildren();

    //console.log("functionCalled");

    // array.forEach((element) => {
    //   element.destroy();
    // });

    // if (array.length > 0) {
    //   array.forEach((element) => {
    //     element.destroy();
    //   });
    // }

    //if (array.length == 0) {
    //points = this.curve.getPoints(divisions);

    gap = 914 / divisions;

    // for (let i = 0; i < points.length; i++) {
    //   var x = this.add.sprite(points[i].x, points[i].y, "linePoint").setFrame(3).setScale(0.67);
    //   this.linePoints.add(x);
    //   //console.log(this.linePoints);
    // }

    for (let i = 0; i < divisions; i++) {
      const x = this.add
        .sprite(184 + gap * i, 575.5, 'linePoint')
        .setFrame(3)
        .setScale(0.67);
      this.linePoints.add(x);
      //console.log(this.linePoints);
    }

    array = this.linePoints.getChildren();

    //return;
    //}

    // points = this.curve.getPoints(divisions);

    // for (let i = 0; i < points.length; i++) {
    //   var x = this.add.sprite(points[i].x, points[i].y, "linePoint").setFrame(3).setScale(0.67);
    //   this.linePoints.add(x);
    // }

    //array = this.linePoints.getChildren();

    //console.log(array);
  }

  controlsSlideIn(targets, start, end) {
    this.tweens.add({
      targets: targets,
      ease: 'Sine.easeInOut',
      duration: 800,
      y: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
    });
  }

  distanceCal() {
    if (gameState.questionNumber == 1) {
      distance = 228.5;
    } else if (gameState.questionNumber == 2) {
      distance = 457;
    } else if (gameState.questionNumber == 3) {
      distance = 304.6;
    } else if (gameState.questionNumber == 4) {
      distance = 101.5;
    } else if (gameState.questionNumber == 5) {
      distance = 228.5;
    } else if (gameState.questionNumber == 6) {
      distance = 152.3;
    } else if (gameState.questionNumber == 7) {
      distance = 304.6;
    } else if (gameState.questionNumber == 8) {
      distance = 182.5;
    } else if (gameState.questionNumber == 9) {
      distance = 130.5;
    } else if (gameState.questionNumber == 10) {
      distance = 114.25;
    }
  }

  moveHeliLeft(durationVal, delayVal, start) {
    this.distanceCal();

    this.tweens.add({
      delay: delayVal,
      targets: this.heliHover,
      ease: 'Sine.easeInOut',
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => start - distance,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        this.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: this.heliaudio,
          ease: 'Linear',
          volume: 0,
          duration: 200,
          onComplete: () => {
            this.heliaudio.stop();
          },
        });
        this.leftButton.playReverse('leftpress');
        this.leftButton.y -= 2.68;
        this.qBoardAppear(this.heliHover.x, 0, 0, 1, 0, 0.67);

        this.time.delayedCall(
          800,
          () => {
            this.leftButton.setInteractive();
            this.rightButton.setInteractive();

            this.dropButton.setInteractive();
          },
          [],
          this,
        );

        this.moveYellowPoint();
      },
    });
  }

  moveHeliRight(durationVal, delayVal, start) {
    this.distanceCal();

    this.tweens.add({
      delay: delayVal,
      targets: this.heliHover,
      ease: 'Sine.easeInOut',
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => start + distance,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        this.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: this.heliaudio,
          ease: 'Linear',
          volume: 0,
          duration: 200,
          onComplete: () => {
            this.heliaudio.stop();
          },
        });
        this.rightButton.playReverse('rightpress');
        this.rightButton.y -= 2.68;
        this.qBoardAppear(this.heliHover.x, 0, 0, 1, 0, 0.67);
        this.time.delayedCall(
          800,
          () => {
            this.leftButton.setInteractive();
            this.rightButton.setInteractive();

            this.dropButton.setInteractive();
          },
          [],
          this,
        );

        this.moveYellowPoint();
      },
    });
  }

  moveHeli_one(durationVal, start, end) {
    this.tweens.add({
      targets: this.heliHover,
      ease: 'Sine.easeInOut',
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
      onComplete: () => {
        // this.sliderButton.drag.setEnable(true);
        this.time.delayedCall(
          1500,
          () => {
            this.sliderButton.setInteractive();
          },
          this,
        );

        this.moveYellowPoint();
      },
    });
  }

  qBoardAppear(newPos, delayVal, alphaStart, alphaEnd, scaleStart, scaleEnd) {
    this.qBoard.x = newPos - 432;

    if (gameState.questionNumber == 1) {
      this.qBoard.setTexture('qBoard_1');
    } else if (gameState.questionNumber == 2) {
      this.qBoard.setTexture('qBoard_2');
    } else if (gameState.questionNumber == 3) {
      this.qBoard.setTexture('qBoard_3');
    } else if (gameState.questionNumber == 4) {
      this.qBoard.setTexture('qBoard_4');
    } else if (gameState.questionNumber == 5) {
      this.qBoard.setTexture('qBoard_5');
    } else if (gameState.questionNumber == 6) {
      this.qBoard.setTexture('qBoard_6');
    } else if (gameState.questionNumber == 7) {
      this.qBoard.setTexture('qBoard_7');
    } else if (gameState.questionNumber == 8) {
      this.qBoard.setTexture('qBoard_8');
    } else if (gameState.questionNumber == 9) {
      this.qBoard.setTexture('qBoard_9');
    } else if (gameState.questionNumber == 10) {
      this.qBoard.setTexture('qBoard_10');
    }

    this.tweens.add({
      targets: this.qBoard,
      ease: 'Quint.easeInOut',
      duration: 800,
      delay: delayVal,
      alpha: {
        getStart: () => alphaStart,
        getEnd: () => alphaEnd,
      },
      scale: {
        getStart: () => scaleStart,
        getEnd: () => scaleEnd,
      },
      yoyo: false,
      loop: 0,
    });
  }

  speechBubbleAppear() {
    if (gameState.questionNumber == 1) {
      this.speechBubble.setTexture('question_1');
      this.time.delayedCall(4000, function () {
        config.audio.qa1.play();
      });
    } else if (gameState.questionNumber == 2) {
      this.speechBubble.setTexture('question_2');
      this.time.delayedCall(4000, function () {
        config.audio.qa2.play();
      });
    } else if (gameState.questionNumber == 3) {
      this.speechBubble.setTexture('question_3');
      this.time.delayedCall(4000, function () {
        config.audio.qa3.play();
      });
    } else if (gameState.questionNumber == 4) {
      this.speechBubble.setTexture('question_4');
      this.time.delayedCall(4000, function () {
        config.audio.qa4.play();
      });
    } else if (gameState.questionNumber == 5) {
      this.speechBubble.setTexture('question_5');
      this.time.delayedCall(4000, function () {
        config.audio.qa5.play();
      });
    } else if (gameState.questionNumber == 6) {
      this.speechBubble.setTexture('question_6');
      this.time.delayedCall(4000, function () {
        config.audio.qa6.play();
      });
    } else if (gameState.questionNumber == 7) {
      this.speechBubble.setTexture('question_7');
      this.time.delayedCall(4000, function () {
        config.audio.qa7.play();
      });
    } else if (gameState.questionNumber == 8) {
      this.speechBubble.setTexture('question_8');
      this.time.delayedCall(4000, function () {
        config.audio.qa8.play();
      });
    } else if (gameState.questionNumber == 9) {
      this.speechBubble.setTexture('question_9');
      this.time.delayedCall(4000, function () {
        config.audio.qa9.play();
      });
    } else if (gameState.questionNumber == 10) {
      this.speechBubble.setTexture('question_10');
      this.time.delayedCall(4000, function () {
        config.audio.qa10.play();
      });
    }
    this.tweens.add({
      targets: this.speechBubble,
      ease: 'Quint.easeInOut',
      duration: 800,
      delay: 3500,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 0.67,
      },
      yoyo: true,
      hold: 2500,
      loop: 0,
      onComplete: () => {
        this.time.delayedCall(
          1500,
          () => {
            this.sliderButton.setInteractive();
          },
          this,
        );
      },
    });
  }

  update() {
    //console.log(this.heliHover.x);

    if (changeQuestion == true) {
      this.sliderButton.x = 485;
      this.numberLineDivide(1);
      gameState.value = 1;
    }

    if (this.sliderButton.x >= 485 && this.sliderButton.x < 503) {
      gameState.value = 1;

      this.numberLineClear();

      this.numberLineDivide(1);
    }
    if (this.sliderButton.x >= 503 && this.sliderButton.x < 521) {
      gameState.value = 2;

      this.sliderButton.x = 503 + 9;

      if (this.sliderButton.x == 503 + 9) {
        this.numberLineClear();
        this.numberLineDivide(2);
      }
    }
    if (this.sliderButton.x >= 521 && this.sliderButton.x < 539) {
      gameState.value = 3;

      this.sliderButton.x = 521 + 9;

      if (this.sliderButton.x == 521 + 9) {
        this.numberLineClear();
        this.numberLineDivide(3);
      }
    }
    if (this.sliderButton.x >= 539 && this.sliderButton.x < 557) {
      gameState.value = 4;

      this.sliderButton.x = 539 + 9;

      if (this.sliderButton.x == 539 + 9) {
        this.numberLineClear();
        this.numberLineDivide(4);
      }
    }
    if (this.sliderButton.x >= 557 && this.sliderButton.x < 575) {
      gameState.value = 5;
      this.sliderButton.x = 557 + 9;
      if (this.sliderButton.x == 557 + 9) {
        this.numberLineClear();
        this.numberLineDivide(5);
      }
    }
    if (this.sliderButton.x >= 575 && this.sliderButton.x < 593) {
      gameState.value = 6;
      this.sliderButton.x = 575 + 9;
      if (this.sliderButton.x == 575 + 9) {
        this.numberLineClear();
        this.numberLineDivide(6);
      }
    }
    if (this.sliderButton.x >= 593 && this.sliderButton.x < 611) {
      gameState.value = 7;

      this.sliderButton.x = 593 + 9;
      if (this.sliderButton.x == 593 + 9) {
        this.numberLineClear();
        this.numberLineDivide(7);
      }
    }
    if (this.sliderButton.x >= 611 && this.sliderButton.x < 629) {
      gameState.value = 8;
      this.sliderButton.x = 611 + 9;
      if (this.sliderButton.x == 611 + 9) {
        this.numberLineClear();
        this.numberLineDivide(8);
      }
    }
    if (this.sliderButton.x >= 629 && this.sliderButton.x < 647) {
      gameState.value = 9;
      this.sliderButton.x = 629 + 9;
      if (this.sliderButton.x == 629 + 9) {
        this.numberLineClear();
        this.numberLineDivide(9);
      }
    }
    if (this.sliderButton.x >= 647 && this.sliderButton.x < 665) {
      gameState.value = 10;

      this.sliderButton.x = 647 + 9;
      if (this.sliderButton.x == 647 + 9) {
        this.numberLineClear();
        this.numberLineDivide(10);
      }
    }
    this.sliderText.x = this.sliderButton.x + 1;
    this.sliderText.y = this.sliderButton.y + 1.5;
    this.sliderText.setText(gameState.value);

    if (this.sliderButton.x < config.width / 2 - 155) {
      this.sliderButton.x = config.width / 2 - 155;
      this.sliderText.x = config.width / 2 - 155 + 1.4;
    }

    if (this.sliderButton.x > config.width / 2 - 155 + 180) {
      //this.sliderButton.x = config.width / 2 - 155 + 180;
      this.sliderText.x = config.width / 2 - 155 + 190 + 1.4;
    }
  }
}
